import { TabOption } from '@packages/types';

export const DEFAULT_TAB = TabOption.CLINICAL_MEASURES;

export const DEFAULT_PAGE_SIZE_CALCULATIONS = 20;
export const DEFAULT_METRICS_PAGE_SIZE = 20;

export const tabOptions = [TabOption.CLINICAL_MEASURES, TabOption.PATIENT_METRICS];
